<template>
  <div class="content">
    <div class="container">
      <div class="flex">
        <div class="main" v-if="this.isMobile">
          <div class="well">
            <p>Deze website is niet beschikbaar op mobiel.</p>
          </div>
        </div>
        <div class="main" v-if="!this.isMobile">
          <a-row v-if="tooOld(data.customer.date_of_birth.value)">
            <a-col :sm="24">
              <h1>{{ data.unemployment.title }}</h1>
              <p>{{ data.unemployment.description }}</p>
              <p>Volgens onze gegevens kunt u deze pagina overslaan.</p>
            </a-col>
          </a-row>
          <a-row v-if="!tooOld(data.customer.date_of_birth.value)">
            <a-col :sm="24">
              <h1>{{ data.unemployment.title }}</h1>
              <p>{{ data.unemployment.description }}</p>
              <strong>Risico's:</strong>
              <ul>
                <li>Uw netto hypotheeklasten gaan omhoog</li>
                <li>Uw besteedbaar inkomen neemt af, u zult moeten bezuinigen</li>
              </ul>
            </a-col>
            <a-col :sm="24">
              <div class="well">
                <a-row class="pt-20" :gutter="50">
                  <a-col span="24">
                    <h2>{{ data.unemployment.sections.section_51.title }}</h2>
                    <p>{{ data.unemployment.sections.section_51.description }}</p>
                  </a-col>
                  <a-col :xs="24" class="pt-10">
                    <strong
                        :class="submitted && data.unemployment.sections.section_51.questions.current_home.error !== null ? 'error-text' : ''">
                      {{ data.unemployment.sections.section_51.questions.current_home.title }}
                    </strong>
                  </a-col>
                  <a-col :xs="24" class="pt-10">
                    <input-radio-group
                        id="unemployment.sections.section_51.questions.current_home.value"
                        :data="data.unemployment.sections.section_51.questions.current_home.value"
                        :label="data.unemployment.sections.section_51.questions.current_home.title"
                        :options="data.unemployment.sections.section_51.questions.current_home.options"
                        :error="submitted && data.unemployment.sections.section_51.questions.current_home.error !== null"
                    />
                  </a-col>
                </a-row>
                <a-row class="pt-20" :gutter="50"
                       v-if="data.unemployment.sections.section_51.questions.current_home.value == 0">
                  <a-col :sm="12">
                    <h3>Het huis waarin ik zou willen wonen:</h3>
                  </a-col>
                  <a-col :sm="12">
                    <h3>In de buurt van:</h3>
                  </a-col>
                  <a-col :sm="12">
                    <input-select
                        id="unemployment.sections.section_51.questions.jumba.home_type.value"
                        :label="data.unemployment.sections.section_51.questions.jumba.home_type.title"
                        :data="data.unemployment.sections.section_51.questions.jumba.home_type.value"
                        :options="data.unemployment.sections.section_51.questions.jumba.home_type.options"
                        :error="submitted && data.unemployment.sections.section_51.questions.jumba.home_type.error !== null"
                    />
                  </a-col>
                  <a-col :sm="12" :lg="6">
                    <input-text
                        id="unemployment.sections.section_51.questions.jumba.search_postal_code.value"
                        :label="data.unemployment.sections.section_51.questions.jumba.search_postal_code.title"
                        :data="data.unemployment.sections.section_51.questions.jumba.search_postal_code.value"
                        :error="submitted && data.unemployment.sections.section_51.questions.jumba.search_postal_code.error !== null"
                    />
                  </a-col>
                  <a-col :sm="12" :lg="6">
                    <input-select
                        id="unemployment.sections.section_51.questions.jumba.search_radius.value"
                        :label="data.unemployment.sections.section_51.questions.jumba.search_radius.title"
                        :data="data.unemployment.sections.section_51.questions.jumba.search_radius.value"
                        :options="data.unemployment.sections.section_51.questions.jumba.search_radius.options"
                        :error="submitted && data.unemployment.sections.section_51.questions.jumba.search_radius.error !== null"
                    />
                  </a-col>
                  <a-col :sm="24" class="pt-20">
                    <jumba-component
                        id="unemployment.sections.section_51.questions.jumba"
                        :value="data.unemployment.sections.section_51.questions.jumba.jumba_id.value"
                        :postal_code="data.unemployment.sections.section_51.questions.jumba.search_postal_code.value"
                        :radius="data.unemployment.sections.section_51.questions.jumba.search_radius.value"
                        :type="data.unemployment.sections.section_51.questions.jumba.home_type.value"
                    />
                  </a-col>
                </a-row>
                <a-row class="pt-30" :gutter="50">
                  <a-col :sm="24" :md="24" :lg="11">
                    <strong
                        :class="submitted && data.unemployment.sections.section_51.questions.becoming_unemployed.error !== null ? 'error-text' : ''">
                      {{ data.unemployment.sections.section_51.questions.becoming_unemployed.title }}
                      <small v-if="data.unemployment.sections.section_51.questions.becoming_unemployed.error !== null">
                        {{ data.unemployment.sections.section_51.questions.becoming_unemployed.error }}
                      </small>
                    </strong>
                  </a-col>
                  <a-col :sm="24" :md="24" :lg="13">
                    <div class="pt-5"
                         v-for="(question, q) in data.unemployment.sections.section_51.questions.becoming_unemployed.questions" :key="question.value">
                      <input-check-box
                          :id="`unemployment.sections.section_51.questions.becoming_unemployed.questions.${q}.value`"
                          :label="question.title"
                          :data="question.value"
                      />
                    </div>
                  </a-col>
                </a-row>
                <a-row class="pt-20">
                  <a-col :sm="24" :md="24" :lg="11"></a-col>
                  <a-col class="ant-col-textarea">
                    <input-text-area
                        id="unemployment.sections.section_51.questions.becoming_unemployed_explanation.value"
                        :placeholder="data.unemployment.sections.section_51.questions.becoming_unemployed_explanation.title"
                        :label="data.unemployment.sections.section_51.questions.becoming_unemployed_explanation.title"
                        :data="data.unemployment.sections.section_51.questions.becoming_unemployed_explanation.value"
                    />
                  </a-col>
                </a-row>
                <a-row class="pt-20" :gutter="50">
                  <a-col :sm="16" :md="16" :lg="11">
                    <strong
                        :class="submitted && data.unemployment.sections.section_51.questions.solution.error !== null ? 'error-text' : ''">
                      {{ data.unemployment.sections.section_51.questions.solution.title }}
                    </strong>
                  </a-col>
                  <a-col :sm="24" :md="24" :lg="13">
                    <input-radio-group
                        id="unemployment.sections.section_51.questions.solution.value"
                        :data="data.unemployment.sections.section_51.questions.solution.value"
                        :label="data.unemployment.sections.section_51.questions.solution.title"
                        :options="data.unemployment.sections.section_51.questions.solution.options"
                    />
                  </a-col>
                </a-row>
                <a-row class="pt-20">
                  <a-col :sm="24" :md="24" :lg="11"></a-col>
                  <a-col class="ant-col-textarea">
                    <input-text-area v-if="data.unemployment.sections.section_51.questions.solution.value == 4"
                                     id="unemployment.sections.section_51.questions.solution.explanation.value"
                                     :placeholder="data.unemployment.sections.section_51.questions.solution.explanation.title"
                                     :label="data.unemployment.sections.section_51.questions.solution.explanation.title"
                                     :data="data.unemployment.sections.section_51.questions.solution.explanation.value"
                    />
                  </a-col>
                </a-row>
              </div>
            </a-col>
            <a-col :sm="24">
              <div class="well" v-if="data.customer.has_partner.value == 1">
                <a-row class="pt-30" :gutter="10">
                  <a-col span="24">
                    <a-row>
                      <a-col span="24">
                        <h2>{{ data.unemployment.sections.section_52.title }}</h2>
                        <p>{{ data.unemployment.sections.section_52.description }}</p>
                      </a-col>
                    </a-row>
                    <a-row class="pt-10" :gutter="50">
                      <a-col :sm="12" :md="10" :lg="12">
                        <strong>{{
                            data.unemployment.sections.section_52.questions.partner_working_time.title
                          }}</strong>
                      </a-col>
                      <a-col :sm="12" :md="14" :lg="12">
                        <a-slider
                            @change="onChangePartnerWorkingTime"
                            id="unemployment.sections.section_52.questions.partner_working_time.value"
                            :value="data.unemployment.sections.section_52.questions.partner_working_time.value"
                            :step=1
                            :min=0
                            :max=40
                            :marks="{0: '0', 8: '8', 16: '16', 24: '24', 32: '32', 40: '40'}"
                        />
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </div>
            </a-col>
          </a-row>
          <a-row class="pt-30">
            <a-col :xs="12" :sm="12" :md="12" :lg="12">
              <a-button class="primary" @click="onPrevious(data)">
                <LeftOutlined />&nbsp;&nbsp;Vorige
              </a-button>
            </a-col>
            <a-col :xs="12" :sm="12" :md="12" :lg="12">
              <a-button class="primary right-align" @click="onSubmit(data)">
                Volgende stap&nbsp;&nbsp;<RightOutlined />
              </a-button>
            </a-col>
          </a-row>
        </div>
        <div class="sidebar">
          <side-nav step="unemployment" :loading="false"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAge, isMobile, nextRoute, previousRoute, router, UNEMPLOYMENT } from '../../../helpers'
import { mapActions } from 'vuex'
import InputRadioGroup from '../../../components/Input/InputRadioGroup'
import InputCheckBox from '../../../components/Input/InputCheckBox'
import InputSelect from '../../../components/Input/InputSelect'
import InputText from '../../../components/Input/InputText'
import InputTextArea from '../../../components/Input/InputTextArea'
import SideNav from '../../../components/SideNav/SideNav'
import JumbaComponent from '../../../components/Jumba/JumbaComponent'
import { alertService } from '../../../services'
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue'

export default {
  name: 'step-unemployment',
  components: {
    SideNav,
    InputText,
    InputTextArea,
    InputSelect,
    InputRadioGroup,
    InputCheckBox,
    JumbaComponent,
    LeftOutlined,
    RightOutlined
  },
  data () {
    return {
      submitted: false,
      isMobile: isMobile()
    }
  },
  computed: {
    data () {
      return this.$store.state.survey
    }
  },
  methods: {
    ...mapActions('survey', ['submit', 'validate']),
    tooOld (dateOfBirth) {
      return getAge(dateOfBirth) > 65
    },
    onChangePartnerWorkingTime (value) {
      this.submit({ name: 'unemployment.sections.section_52.questions.partner_working_time.value', value })
    },
    onPrevious (data) {
      router.push(previousRoute(UNEMPLOYMENT, data.customer.has_partner.value, data.customer.invitation.type.value))
    },
    onSubmit (data) {
      this.submitted = true
      this.validate({ key: UNEMPLOYMENT, data })
      if (data.status.unemployment) {
        router.push(nextRoute(UNEMPLOYMENT, data.customer.has_partner.value, data.customer.invitation.type.value))
      } else {
        alertService.onError('Niet alle velden zijn ingevuld')
      }
    }
  }
}
</script>
